import { FilePostRequestBody, FilePostResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateFile = () => {
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: FilePostRequestBody) =>
      client
        .post('file', {
          json: {
            ...body,
          },
        })
        .json<FilePostResponse>(),
  });
  return { ...result, createFileAsync: result.mutateAsync };
};
